import React from "react";
import PropTypes from "prop-types";
import { TextFieldProps } from "@material-ui/core";
import { textFieldTypes, StyledTextField } from "./styles";

export default function CobeeTextField({
  styleType,
  variant,
  minWidth,
  min,
  max,
  step,
  name = "",
  ...rest
}: {
  styleType: "default" | "underlined";
  variant: string;
  minWidth: string | number;
  min: number | string;
  max: number | string;
  step: number | string;
  name?: string;
} & TextFieldProps) {
  const textFieldStyles = textFieldTypes({ minWidth, ...rest });

  return (
    <StyledTextField
      {...rest}
      name={name}
      variant={variant || "outlined"}
      className={`${textFieldStyles.default} ${
        styleType && textFieldStyles?.[styleType]
      }`}
      inputProps={{ min, max, step, "aria-label": name }}
    />
  );
}

CobeeTextField.defaultProps = {
  styleType: undefined,
  variant: undefined,
  minWidth: undefined,
  min: undefined,
  max: undefined,
  step: undefined,
};

CobeeTextField.propTypes = {
  styleType: PropTypes.string,
  variant: PropTypes.string,
  minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.string,
};
